
import { useState, useCallback } from 'react';
import { AdminService } from '../../../../application/services/AdminService';
import { useToast } from '../../../../context/ToastContext';

export const useReportes = () => {
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);
    const [reportData, setReportData] = useState(null);

    // Filtros
    const [selectedReport, setSelectedReport] = useState("");
    const [fechaInicio, setFechaInicio] = useState("");
    const [fechaFin, setFechaFin] = useState("");
    const [selectedDate, setSelectedDate] = useState(""); // fechas individuales
    const [tipoReporte, setTipoReporte] = useState('dia'); // dia | mes

    const toast = useToast();

    const fetchReport = useCallback(async () => {
        if (!selectedReport) return;

        setLoading(true);
        setError(null);
        setReportData(null);

        try {
            let data = null;

            switch (selectedReport) {
                case 'medidores':
                    data = await AdminService.getReporteMedidores();
                    break;
                case 'clientes':
                    data = await AdminService.getAllClientes(); // Reusal de getAllClientes si la estructura es compatible
                    break;
                case 'suma-total':
                    if (!selectedDate) throw new Error("Seleccione una fecha");
                    data = await AdminService.getReporteSumaTotal(selectedDate);
                    break;

                case 'reporte-rango':
                    if (!fechaInicio || !fechaFin) throw new Error("Seleccione rango de fechas");
                    data = await AdminService.getReporteEconomico(fechaInicio, fechaFin);
                    break;
                case 'morosos':
                    data = await AdminService.getReporteMora();
                    break;
                default:
                    break;
            }

            setReportData(data);
        } catch (err) {
            console.error(err);
            setError(err.message || "Error al generar reporte");
            toast.error(err.message || "Error al generar reporte");
        } finally {
            setLoading(false);
        }
    }, [selectedReport, fechaInicio, fechaFin, selectedDate, toast]);

    const resetReport = () => {
        setReportData(null);
        setError(null);
    };

    return {
        loading,
        error,
        reportData,
        selectedReport,
        setSelectedReport,
        fechaInicio,
        setFechaInicio,
        fechaFin,
        setFechaFin,
        selectedDate,
        setSelectedDate,
        tipoReporte,
        setTipoReporte,
        fetchReport,
        resetReport
    };
};
